var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "#969BB4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.333336H24V3H0V0.333336ZM0 9.66667H24V12.3333H0V9.66667ZM0 19H24V21.6667H0V19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamburgerMenu);
export default __webpack_public_path__ + "static/media/gamburger-menu.dec5c925e7101fe49d6fd745c94567d7.svg";
export { ForwardRef as ReactComponent };